import { Link, useLocation } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden px-4 py-24 text-center">
      <span
        className="pointer-events-none absolute select-none font-heading text-[9rem] font-black leading-none text-background-200 md:text-[15rem]"
        aria-hidden="true"
      >
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1 text-xs font-label font-bold text-primary-700">
          <i className="ri-error-warning-line" aria-hidden="true" />
          页面走丢了
        </span>
        <h1 className="mt-5 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
          这条瓜好像被撤下了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的页面已经不存在或链接有误。返回首页看看今天最新的爆料追踪。
        </p>
        <p className="mt-3 rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-label font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
          {topics.slice(0, 3).map((topic) => (
            <Link
              key={topic.slug}
              to={`/topic/${topic.slug}`}
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              {topic.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}